/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coached_Training_Crumb_ListInputs */

const en_coached_training_crumb_list = /** @type {(inputs: Coached_Training_Crumb_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainings`)
};

const pl_coached_training_crumb_list = /** @type {(inputs: Coached_Training_Crumb_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treningi`)
};

/**
* | output |
* | --- |
* | "Trainings" |
*
* @param {Coached_Training_Crumb_ListInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coached_training_crumb_list = /** @type {((inputs?: Coached_Training_Crumb_ListInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coached_Training_Crumb_ListInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coached_training_crumb_list(inputs)
	return en_coached_training_crumb_list(inputs)
});